import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './core/components/login/login.component';
import { ShipmentListComponent } from './modules/shipment/shipment-list/shipment-list.component';
import { SearchAdressComponent } from './modules/address/search-adress/search-adress.component';
import { MawListComponent } from './modules/maw/maw-list/maw-list.component';
import { LoginRedirectGuard } from './core/guards/login-redirect.guard';
import { EnsureAuthenticated } from './core/guards/ensure-authenticated.guard';
import { CustomerOnboardingComponent } from './modules/configuration/customer-onboarding/customer-onboarding.component';
import { DirtyCheckGuard } from './core/guards/dirty-check.guard';
import { UsersListComponent } from './core/components/user-management/users-list/users-list.component';
import { ChangePasswordComponent } from './core/components/change-password/change-password.component';
import { ResetPasswordComponent } from './core/components/reset-password/reset-password.component';
import { BbxMappingComponent } from './modules/mapping/bbx-mapping/bbx-mapping.component';
import { PickupListComponent } from './modules/pickups/pickup-list/pickup-list.component';
import { CreateReportsComponent } from './modules/reports/create-reports/create-reports.component';

import { DetectComponent } from './modules/akamai/detect/detect.component';
import { SorryPageComponent } from './modules/akamai/sorry-page/sorry-page.component';
import { SurerouteTestComponent } from './modules/akamai/sureroute-test/sureroute-test.component';
import { UpgradeBrowserComponent } from './modules/akamai/upgrade-browser/upgrade-browser.component';

const routes: Routes = [
  {
    path: 'shipment-list',
    component: ShipmentListComponent,
    canActivate: [EnsureAuthenticated],
    children: [{ path: '', redirectTo: 'shipment-list', pathMatch: 'full' }],
  },
  {
    path: 'mapping',
    component: BbxMappingComponent,
    canActivate: [EnsureAuthenticated],
    canDeactivate: [DirtyCheckGuard],
  },
  {
    path: 'search-adress',
    component: SearchAdressComponent,
    canActivate: [EnsureAuthenticated],
  },
  {
    path: 'maw-list',
    component: MawListComponent,
    canActivate: [EnsureAuthenticated],
  },
  {
    path: 'customer-onboarding',
    component: CustomerOnboardingComponent,
    canActivate: [EnsureAuthenticated],
  },
  {
    path: 'users-list',
    component: UsersListComponent,
    canActivate: [EnsureAuthenticated],
  },
  {
    path: 'pickups',
    component: PickupListComponent,
    canActivate: [EnsureAuthenticated],
  },
  {
    path: 'reports',
    component: CreateReportsComponent,
    canActivate: [EnsureAuthenticated],
  },
  { path: 'change-password', component: ChangePasswordComponent },
  { path: 'reset-password/:id', component: ResetPasswordComponent },
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [LoginRedirectGuard],
  },
  { path: '', pathMatch: 'full', redirectTo: 'login' },
  {
    path: 'akamai',
    children: [
      { path: 'detect', component: DetectComponent },
      { path: 'sorry-page', component: SorryPageComponent },
      { path: 'sureroute-test', component: SurerouteTestComponent },
      { path: 'upgrade-browser', component: UpgradeBrowserComponent },
    ],
  },
];

@NgModule({
  declarations: [],
  imports: [CommonModule, BrowserModule, RouterModule.forRoot(routes)],
})
export class AppRoutingModule {}
